/* Siete Notas — Quiz (módulo 7N sobre Horizon) "Encuentra tu nota" */
(function () {
  'use strict';

  var NOTE_LABELS = { Dulce: 'Dulce', Especiada: 'Especiada', Amaderada: 'Amaderada', Fresca: 'Fresca', Floral: 'Floral', Ambar: 'Ámbar', Oud: 'Oud' };

  function handleize(s) {
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function initQuiz(root) {
    var products = JSON.parse(root.querySelector('[data-quiz-products]').textContent || '[]');
    var notes = JSON.parse(root.querySelector('[data-quiz-notes]').textContent || '{}');
    var intro = root.querySelector('[data-quiz-intro]');
    var form = root.querySelector('[data-quiz-form]');
    var questions = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-q]'));
    var bar = root.querySelector('[data-quiz-bar]');
    var stepEl = root.querySelector('[data-quiz-step]');
    var back = root.querySelector('[data-quiz-back]');
    var result = root.querySelector('[data-quiz-result]');
    var wa = root.dataset.wa;
    var collectionsUrl = root.dataset.collectionsUrl || '/collections';
    var step = 0;
    // Siete Notas: si se envió el formulario de correo (MKT-12), mostrar la confirmación o el error al recargar.
    var saveBox = root.querySelector('[data-quiz-save]');
    if (saveBox && saveBox.querySelector('[data-quiz-save-ok], .sn-form-error')) saveBox.hidden = false;

    function show(i) {
      step = i;
      questions.forEach(function (q, idx) { q.hidden = idx !== i; });
      bar.style.width = ((i) / questions.length * 100) + '%';
      stepEl.textContent = 'Pregunta ' + (i + 1) + ' de ' + questions.length;
      back.hidden = i === 0;
      var first = questions[i].querySelector('input');
      if (first) first.focus({ preventScroll: true });
    }

    function answers() {
      var tags = [];
      questions.forEach(function (q) {
        var c = q.querySelector('input:checked');
        if (c) c.value.split(',').forEach(function (t) { t = t.trim(); if (t) tags.push(t); });
      });
      return tags;
    }

    function compute() {
      var tags = answers();
      var noteScore = {};
      tags.forEach(function (t) {
        if (t.indexOf('Nota_') === 0) { var n = t.slice(5); noteScore[n] = (noteScore[n] || 0) + 1; }
      });
      var topNote = Object.keys(noteScore).sort(function (a, b) { return noteScore[b] - noteScore[a]; })[0] || 'Dulce';
      var gender = tags.filter(function (t) { return t.indexOf('Genero_') === 0; });

      var scored = products
        .filter(function (p) { return p.tags.indexOf('Mini') === -1; })
        .map(function (p) {
          var s = 0;
          tags.forEach(function (t) {
            if (p.tags.indexOf(t) !== -1) s += t.indexOf('Nota_') === 0 ? 3 : 1;
          });
          if (p.tags.indexOf('Nota_' + topNote) !== -1) s += 4;
          // Género: un perfume de otro género (y no unisex) baja mucho
          if (gender.length && gender[0] !== 'Genero_Unisex') {
            var fits = p.tags.indexOf(gender[0]) !== -1 || p.tags.indexOf('Genero_Unisex') !== -1;
            if (!fits) s -= 10;
          }
          return { p: p, s: s };
        })
        .sort(function (a, b) { return ((b.p.available ? 1 : 0) - (a.p.available ? 1 : 0)) || (b.s - a.s); })
        .slice(0, 3)
        .map(function (x) { return x.p; });

      var mini = products.find(function (p) {
        return p.available && p.tags.indexOf('Mini') !== -1 && p.tags.indexOf('Nota_' + topNote) !== -1;
      });
      return { note: topNote, top: scored, mini: mini };
    }

    function card(p, i) {
      return '<article class="sn-card">' +
        '<p class="sn-quiz__rank">' + (i === 0 ? 'Tu mejor opción' : 'Opción ' + (i + 1)) + '</p>' +
        '<a class="sn-card__media" href="' + esc(p.url) + '">' +
          (p.img ? '<img class="sn-card__img" src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="sn-card__body">' +
          '<p class="sn-card__vendor">' + esc(p.vendor) + '</p>' +
          '<h3 class="sn-card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
          '<div class="sn-price"><span class="sn-price__current">' + esc(p.price) + '</span></div>' +
          (p.available ? '<button type="button" class="sn-btn sn-btn--small sn-card__add" data-quick-add="' + p.id + '">Agregar</button>' : '<a class="sn-btn sn-btn--small sn-btn--outline sn-card__add" href="' + esc(p.url) + '">Próximamente · Ver</a>') +
        '</div></article>';
    }

    function renderResult() {
      var r = compute();
      var label = NOTE_LABELS[r.note] || r.note;
      form.hidden = true;
      result.hidden = false;
      result.querySelector('[data-result-nota]').textContent = label;
      result.querySelector('[data-result-desc]').textContent = notes[r.note] || '';
      result.querySelector('[data-result-products]').innerHTML = r.top.length
        ? r.top.map(card).join('')
        : '<p class="sn-empty-note">Todavía no tenemos perfumes en esta nota. Escríbenos y te recomendamos uno.</p>';
      result.querySelector('[data-result-collection]').href = collectionsUrl + '/' + handleize(r.note);

      var miniEl = result.querySelector('[data-result-mini]');
      if (r.mini) {
        miniEl.hidden = false;
        miniEl.innerHTML = (r.mini.img ? '<img src="' + esc(r.mini.img) + '" alt="" loading="lazy">' : '') +
          '<p><strong>¿Prefieres probar primero?</strong><br>Mini de ' + esc(r.mini.title) + ' · ' + esc(r.mini.price) + '. Su valor se descuenta al comprar el frasco.</p>' +
          '<button type="button" class="sn-btn sn-btn--small sn-btn--outline" data-quick-add="' + r.mini.id + '">Agregar mini</button>';
      } else {
        miniEl.hidden = true;
      }

      var waBtn = result.querySelector('[data-result-wa]');
      if (waBtn && wa) {
        var msg = 'Hola Siete Notas, hice el test y mi nota es ' + label + '.' + (r.top.length ? ' Me recomendaron: ' +
          r.top.map(function (p) { return p.title; }).join(', ') + '.' : '') + ' ¿Me ayudan a elegir?';
        waBtn.href = 'https://wa.me/' + wa + '?text=' + encodeURIComponent(msg);
      }
      bar.style.width = '100%';
      if (saveBox) {
        var tg = saveBox.querySelector('[data-quiz-tags]');
        if (tg) tg.value = 'quiz, quiz_' + handleize(r.note);
        saveBox.hidden = false;
      }
      result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    root.querySelector('[data-quiz-start]').addEventListener('click', function () {
      intro.hidden = true;
      form.hidden = false;
      show(0);
    });

    form.addEventListener('change', function (e) {
      if (e.target.type !== 'radio') return;
      setTimeout(function () {
        if (step < questions.length - 1) show(step + 1);
        else renderResult();
      }, 220);
    });

    back.addEventListener('click', function () { if (step > 0) show(step - 1); });

    root.querySelector('[data-quiz-restart]').addEventListener('click', function () {
      form.reset();
      result.hidden = true;
      form.hidden = false;
      show(0);
    });
  }

  function boot() { document.querySelectorAll('[data-quiz]').forEach(initQuiz); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
